import { PRACTICE_TIMER_BELL_TYPES } from "src/consumer/constants";

export const BELL_TYPES_OPTIONS = [
  { id: PRACTICE_TIMER_BELL_TYPES.bell, title: 'Bell' },
  { id: PRACTICE_TIMER_BELL_TYPES.none, title: 'No Bell' },
  { id: PRACTICE_TIMER_BELL_TYPES.vibrate, title: 'Vibrate' },
]
